import { Shimmer as e } from "@ado/acs-standard-library";
import { defineComponent as o } from "vue";
import r from "./index10.js";
import "@ado/acs-standard-library/style.css";
const i = o({
  name: "HeaderSkeleton",
  components: {
    Shimmer: e,
    HeaderLogo: r
  },
  props: {
    config: {
      type: Object,
      required: !0
    }
  }
});
export {
  i as default
};
//# sourceMappingURL=index20.js.map
